var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeekrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 29,
    viewBox: "0 0 115 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3355_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0757 25.7588H19.0554V17.0847L12.035 10.0663V2.33946H26.0675L26.0757 25.7588ZM2.67723 25.7588V2.33946H9.68937V11.0301L16.7097 18.0485V25.7506L2.67723 25.7588ZM28.4131 0H0.339844V28.0982H28.4131V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3248 9.49053L43.0493 17.0855H49.9462V18.6342H39.2305V18.6013L46.506 11.0145H39.6338V9.46582H50.333V9.49053H50.3248Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8192 18.6424L89.0951 13.9059V18.6424H87.2188V9.46582H89.0951V13.8811L95.6299 9.46582H98.5187L91.951 13.8482L98.741 18.6342H95.8192V18.6424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.741 18.6424L109.647 15.2156H110.593C112.387 15.2156 113.959 14.1859 113.959 12.4396V12.316C113.959 10.5367 112.371 9.46582 110.527 9.46582H103.062V18.6342H104.939V13.8482L111.976 18.6342H114.741V18.6424ZM104.931 11.0227H110.56C111.26 11.0227 111.91 11.3028 112.091 11.8712C112.099 11.97 112.124 12.2089 112.124 12.4478C112.124 12.6949 112.108 12.9338 112.091 13.0244C111.902 13.5269 111.26 13.8317 110.56 13.8317H104.931V11.0227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5477 17.0114V18.6424H56.0254V9.46582H65.5477V11.0969H57.8443V13.0656H65.1445V14.6967H57.8443V17.0032H65.5477V17.0114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1454 17.0114V18.6424H71.623V9.46582H81.1454V11.0969H73.4419V13.0656H80.7421V14.6967H73.4419V17.0032H81.1454V17.0114Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3355_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 29,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeekrLogo);
export default ForwardRef;